import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/gallery";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4">
        <a href="#top" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 ${
              scrolled ? "" : ""
            }`}
          >
            <i className="ri-sun-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg font-semibold tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            橘海同人馆
          </span>
        </a>

        <ul
          className={`hidden items-center gap-7 md:flex ${
            scrolled ? "text-foreground-800" : "text-background-50/90"
          }`}
        >
          {navLinks.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="text-sm transition-colors hover:text-primary-500 cursor-pointer whitespace-nowrap"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <a
            href="#subscribe"
            className={`inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50/15 text-background-50 hover:bg-primary-500 hover:text-background-50"
            }`}
          >
            订阅更新
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-900"
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <ul className="mx-auto flex max-w-7xl flex-col px-4 py-2">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block border-b border-background-100 py-3 text-sm text-foreground-800 cursor-pointer"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="mt-3 mb-2 inline-flex w-full items-center justify-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
              >
                订阅更新
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}